export const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 2000 }, items: 5,slidesToSlide: 3  },
    desktop: { breakpoint: { max: 2000, min: 1024 }, items: 3,slidesToSlide: 3 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2,slidesToSlide: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
  };